import React from 'react';
import { motion } from 'motion/react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const springConfig = {
    type: "spring",
    damping: 80,
    stiffness: 400,
    mass: 1
};

const Disclaimer = () => {
    return (
        <div className="min-h-screen">
            <Header />

            {/* Hero Section */}
            <section className="pt-32 pb-20 px-6 bg-gradient-to-br from-orange-50 via-yellow-50 to-green-50">
                <div className="container mx-auto max-w-7xl text-center">
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={springConfig}
                    >
                        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-yellow-500">Disclaimer</span>
                        </h1>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Last Updated: January 29, 2025
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* Content */}
            <section className="py-20 px-6 bg-white">
                <div className="container mx-auto max-w-4xl">
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ ...springConfig, delay: 0.2 }}
                        className="prose prose-lg max-w-none"
                    >
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">1. Educational Purpose Only</h2>
                        <p className="text-gray-600 mb-4">
                            Goodikids provides general educational and values-based content for children. It is meant to support learning, not replace formal education or professional guidance.
                        </p>
                        <p className="text-gray-600 mb-6">
                            Goodikids does not provide:
                        </p>
                        <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
                            <li>Medical or psychological advice</li>
                            <li>Behavioral or therapeutic guidance</li>
                            <li>Professional educational instruction</li>
                        </ul>

                        <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">2. No Guaranteed Results</h2>
                        <p className="text-gray-600 mb-6">
                            Every child learns differently. Goodikids does not guarantee specific improvements in behavior, values, academics, or learning outcomes.
                        </p>

                        <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">3. Parental Responsibility</h2>
                        <p className="text-gray-600 mb-4">
                            Goodikids may be used by children only under parent or guardian supervision. Parents are responsible for:
                        </p>
                        <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
                            <li>Monitoring their child’s use of the app</li>
                            <li>Reviewing the learning content</li>
                            <li>Managing screen time</li>
                        </ul>
                        <p className="text-gray-600 mb-6">
                            Goodikids is not responsible for how children interpret or apply the content.
                        </p>

                        <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">4. No Professional Relationship</h2>
                        <p className="text-gray-600 mb-6">
                            Using Goodikids does not create any professional relationship with educators, therapists, or specialists.
                        </p>

                        <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">5. App & Website Content</h2>
                        <p className="text-gray-600 mb-4">
                            We strive to provide accurate and safe content, but we do not guarantee:
                        </p>
                        <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
                            <li>Error-free content</li>
                            <li>Continuous availability</li>
                            <li>Accuracy of third-party links or services</li>
                        </ul>
                        <p className="text-gray-600 mb-6">
                            Goodikids is not liable for technical issues, connectivity problems, or data loss.
                        </p>

                        <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">6. External Links</h2>
                        <p className="text-gray-600 mb-6">
                            Any external website or third-party link inside the app or website is not controlled by Goodikids. We are not responsible for their content or practices.
                        </p>

                        <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">7. Contact</h2>
                        <p className="text-gray-600 mb-6">
                            For questions about this Disclaimer:
                            <br />
                            📧 Email: <a href="mailto:legal@goodikids.com" className="text-orange-500 hover:text-orange-600">legal@goodikids.com</a>
                        </p>
                    </motion.div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Disclaimer;
